import React, { useEffect, useState } from 'react';
import { logo, whatsapp, icon1, icon2, icon3, icon4, azFlag, rusFlag, engFlag, fraFlag, arbFlag, service1, service2, service3, service4, service5, service6, icon5 } from '../../assets/images';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useTranslation, initReactI18next } from "react-i18next";
import i18n from "i18next";
import enTranslation from "../i18n/en/translation.json";
import azTranslation from "../i18n/az/translation.json";
import rusTranslation from "../i18n/rus/translation.json";
import arbTranslation from "../i18n/arb/translation.json";
import fraTranslation from "../i18n/fra/translation.json";
import { NavLink } from "react-router-dom";


const products = [
  { id: 1, image: service1,  title: "Azərbaycanda Təcrübə İmkanları", description: "Xaricdən gələn həkimlər və tibb tələbələri üçün Azərbaycanda yüksək səviyyəli tibb müəssisələrində təcrübə keçmək imkanı yaradırıq. Bu, Azərbaycan səhiyyə sistemini tanımaq və yerli mütəxəssislərlə birgə işləmək şansı təqdim edir." },
  { id: 2, image: service2, title: "Xaricdə Təcrübə İmkanları", description: "Dünyaca tanınmış həkimlər və yüksək ixtisaslı tibbi personal ilə xidmət göstəririk." },
  { id: 3, image: service3, title: "Qlobal Sanatoriya Şəbəkəsi", description: "Dünyaca tanınmış həkimlər və yüksək ixtisaslı tibbi personal ilə xidmət göstəririk." },
  { id: 4, image: service4, title: "Azərbaycanda Tibbi Müalicə", description: "Dünyaca tanınmış həkimlər və yüksək ixtisaslı tibbi personal ilə xidmət göstəririk." },
  { id: 5, image: service5, title: "Xaricdə Tibbi Müalicə", description: "Dünyaca tanınmış həkimlər və yüksək ixtisaslı tibbi personal ilə xidmət göstəririk." },
  { id: 6, image: service6, title: "Qlobal Həkim Mübadiləsi", description: "Dünyaca tanınmış həkimlər və yüksək ixtisaslı tibbi personal ilə xidmət göstəririk." },
];

const Header = () => {

  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredProducts = searchQuery
    ? products.filter((product) =>
        product.title.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const location = useLocation(); // Get current route

  // Function to check if the current path is active
  const isActiveLink = (path) => location.pathname === path;

  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);
  const toggleHamburgerMenu = () => setIsHamburgerMenuOpen(!isHamburgerMenuOpen);

  const { t, i18n } = useTranslation();

 


  return (
    <>
      <div className='bg-[#388E3C] hidden md:block'>
        <div className='max-w-containerSm md:max-w-container mx-auto h-[60px] flex justify-between'>
          <button className="md:hidden focus:outline-none" onClick={toggleHamburgerMenu}>
            <i className="fa-solid fa-bars text-[24px] text-[black]"></i>
            {isHamburgerMenuOpen && (
              <div className={`fixed inset-y-0 bg-[white] left-0 transform ${isHamburgerMenuOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out w-full z-50 shadow-lg`}>
                <div className="flex">
                  <button className="absolute top-5 right-5 p-2 rounded" onClick={toggleHamburgerMenu}>
                    <i className="fa-solid fa-xmark text-[32px] text-[black]"></i>
                  </button>
                </div>
                <div className="flex flex-col items-start p-8 w-full">
                  <div className="items-center justify-center sm:justify-end space-x-2 space-y-2 sm:space-y-0 h-screen">
                    <div className="gap-4 max-w-containerSm flex flex-col">
                      <a href='/'> <img src={logo} alt="Logo" className="w-[109px] mb-5" /></a>
                      <a className={`text-base text-left font-normal ${isActiveLink('/') ? 'text-[#587257]' : 'text-[black]'}`} href="/"> {t("Əsas səhifə")}</a>
                      <a href="/why-us" className={`text-base text-left font-normal ${isActiveLink('/products') ? 'text-[#587257]' : 'text-[black]'}`}>{t("Niyə biz?")}</a>
                      <a href="/services" className={`text-base text-left font-normal ${isActiveLink('/about') ? 'text-[#587257]' : 'text-[black]'}`}>{t("Xidmətlərimiz")}</a>
                      <a href="/care" className={`text-base text-left font-normal ${isActiveLink('/blogs') ? 'text-[#587257]' : 'text-[black]'}`}>{t("Müalicə və prosedurlar")}</a>
                                            <a href="/experience" className={`text-base text-left font-normal ${isActiveLink('/experience') ? 'text-[#587257]' : 'text-[black]'}`}>{t("Təcrübə proqramı")}</a>
                      <a href="/faq" className={`text-base text-left font-normal ${isActiveLink('/kampaniya') ? 'text-[#587257]' : 'text-[black]'}`}>{t("FAQ")}</a>
                      <a href="/blogs" className={`text-base text-left font-normal ${isActiveLink('/contact') ? 'text-[#587257]' : 'text-[black]'}`}>{t("Bloq")}</a>
                      <a href="/contact" className={`text-base text-left font-normal ${isActiveLink('/contact') ? 'text-[#587257]' : 'text-[black]'}`}>{t("Əlaqə")}</a>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </button>
          <div className='flex items-center gap-5 text-white'>
            <div className='flex gap-2'>
              <img className='h-6 w-6' src={icon5} />
              <p>+994 50 201 78 24</p>
            </div>
            <div className='flex gap-2'>
              <img className='h-6 w-6' src={icon4} />
              <p>info@hevo.az</p>
            </div>
          </div>
          <div className="flex items-center justify-end relative ">
            <div className="bg-opacity-50 z-10 flex justify-center items-center">
              <div >
                <input 
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder={t("Axtar...")}
                  className="p-2 rounded-[9px] w-[400px] text-black"
                />
              </div>
            </div>
          </div>

          <div className='md:flex items-center w-[300px] hidden justify-end'>
            <nav>
              <ul className="flex justify-between text-[black] gap-3">
                <a href='https://wa.me/message/4LSQ26VIZ572B1'><img className='h-6 w-6' src={icon1} /></a>
                <a href='https://www.linkedin.com/company/hevo.az/'><img className='h-6 w-6' src={icon2} /></a>
                <a href='https://www.instagram.com/hevo.company/profilecard/?igsh=bXkyYmwyZXc2cjdu'><img className='h-6 w-6' src={icon3} /></a>
              </ul>
            </nav>
          </div>
        </div>
        {searchQuery && (
          <div className="absolute top-0 left-0 w-full bg-white z-50 mt-[86px] grid grid-cols-3 px-10 gap-5">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((item) => (
                <a href={`/services`}>
                  <div key={item.id} className="rounded-[20px] py-4 w-[400px] h-[220px] px-3 shadow bg-white">
                <img className="h-[50px] w-[50px] mx-auto" src={item.image} alt="Opportunity" />
                <div>
                  <p className="mt-[12px] text-[22px] font-medium text-center">{item.title}</p>
                  <p className="mt-[12px] mb-[32px] text-center">
                    {item.description.length > 80 ? item.description.slice(0,80) + '...' : item.description}
                  </p>
                </div>
              </div>
                </a>
              ))
            ) : (
              <p className="text-white text-center">No results found</p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
